import { API } from "./env";
import { axiosInstance } from "./httpClient";

export class SalesAgreementsApi {
    static getSalesAgreements = async (filters = {}) => {
        const userInfo = JSON.parse(localStorage.getItem("user"));
        const accessToken = userInfo.token;

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        // Prepare query parameters for the company_sale table
        const queryParams = {
            page: filters.page || 1,
            limit: filters.resultsPerPage || 10,
            companyName: filters.companyName || '',
            planType: filters.planType !== 'all' ? filters.planType : '',
            approvalStatus: filters.approvalStatus !== 'all' ? filters.approvalStatus : '',
            dateFrom: filters.dateFrom || '',
            dateTo: filters.dateTo || ''
        };

        try {
            const response = await axiosInstance.post(`${API}/admin/sales`, queryParams, config);
            return response;
        } catch (error) {
            console.error('Failed to fetch sales agreements from backend:', error);

            // Check if it's a 404 (endpoint not found) or other expected error
            if (error.response && (error.response.status === 404 || error.response.status === 400)) {
                // Return empty data structure for graceful handling
                return {
                    data: {
                        agreements: [],
                        totalCount: 0,
                        totalPages: 0,
                        message: 'Sales feature is not yet implemented in the backend.'
                    }
                };
            }

            throw error;
        }
    };

    static createSalesAgreement = async (agreementData) => {
        const userInfo = JSON.parse(localStorage.getItem("user"));
        const accessToken = userInfo.token;

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        try {
            const response = await axiosInstance.post(`${API}/admin/sales/create`, agreementData, config);
            return response;
        } catch (error) {
            console.error('Failed to create sales agreement:', error);
            throw error;
        }
    };

    static updateSalesAgreement = async (id, agreementData) => {
        const userInfo = JSON.parse(localStorage.getItem("user"));
        const accessToken = userInfo.token;

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        try {
            const response = await axiosInstance.put(`${API}/admin/sales/${id}`, agreementData, config);
            return response;
        } catch (error) {
            console.error('Failed to update sales agreement:', error);
            throw error;
        }
    };

    static deleteSalesAgreement = async (id) => {
        // Input validation
        if (!id) {
            throw new Error('Sales agreement ID is required');
        }

        const numericId = Number(id);
        if (isNaN(numericId) || numericId <= 0) {
            throw new Error('Invalid sales agreement ID - must be a positive number');
        }

        const userInfo = JSON.parse(localStorage.getItem("user"));
        const accessToken = userInfo.token;

        const config = {
            method: 'delete',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        try {
            const response = await axiosInstance.delete(`${API}/admin/sales/${id}`, config);
            return response;
        } catch (error) {
            console.error('Failed to delete sales agreement:', error);
            throw error;
        }
    };

}

export default SalesAgreementsApi;
